import { defineStore } from 'pinia';
import {ServicesMap, SuiteSettings, UserSettings, Settings, UserPreferences} from '@/models/settings';
import { apiFetch } from '@/services/ApiClient.ts';
import {StorageService} from "@/services/storageService.ts";

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        services: {} as ServicesMap,
        suiteSettings: {} as SuiteSettings,
        userSettings: {} as Settings,
        userProfileImage: '',
        isLoading: false,
        initialized: false,
    }),

    getters: {
        hasSuiteSettings: (state) => {
            return !!state.suiteSettings?.defaultLanguage || Object.keys(state.suiteSettings).length > 0;
        }
    },

    actions: {
        async fetchSuiteSettings() {
            try {
                const response = await apiFetch('/suiteSettings');

                const text = await response.text();
                if (!text) throw new Error("Empty response from server");

                const jsonResponse = JSON.parse(text);

                if (!response.ok) throw jsonResponse;

                this.suiteSettings = jsonResponse.data;
            } catch (error) {
                console.error("Failed to fetch suite settings:", error);
            }
        },

        async fetchServicesSettings() {
            this.isLoading = true;
            try {
                const response = await apiFetch('/settings');

                const text = await response.text();
                if (!text) throw new Error("Empty response from server");

                const jsonResponse = JSON.parse(text);

                if (!response.ok) throw jsonResponse;
                const data: UserSettings = jsonResponse.data;
                const servicesData = data.services || {};
                for (const serviceId in servicesData) {
                    if (servicesData[serviceId]) {
                        servicesData[serviceId]['id'] = serviceId;
                    }
                }

                for (const key in this.services) {
                    delete this.services[key];
                }
                this.services = servicesData;
                this.userSettings = data.settings;
                this.userProfileImage = data.profileImage;

                await StorageService.Set("USER_PREFERENCES", this.userSettings.userPreferences)
                this.initialized = true;
            } catch (error) {
                console.error("Failed to fetch services settings:", error);
            } finally {
                this.isLoading = false;
            }
        },

        async updateServicesSettings(profileImage: string, userPreferences: UserPreferences) {
            this.isLoading = true;

            interface UpdateSettingsRequestAndResponse {
                profileImage: string;
                preferences: UserPreferences
            }

            const request: UpdateSettingsRequestAndResponse = {
                profileImage: profileImage,
                preferences: userPreferences
            };
            try {
                const response = await apiFetch('/updateUserSettings', {
                    method: 'POST',
                    body: JSON.stringify(request),
                });
                const resp = await response.json()
                const data: UpdateSettingsRequestAndResponse = resp.data;
                this.userSettings.userPreferences = data.preferences;
                this.userProfileImage = data.profileImage;
            } catch (error) {
                return error;
            }
            this.isLoading = false;
            return null;
        }
    }
});